import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';

import { IClientActions, IThunkGetClientOptions } from '../types';

const onGetClientOptions: IThunkGetClientOptions = thunk(
  async ({ setClientOptionsByTeam, setClient }: Actions<IClientActions>, payload) => {
    const data = await api.client.getClientsOptions(payload).then(r => r.data);

    const teamId = payload.teamIds?.[0];

    let archived: number[] = [];

    if (teamId && !payload.includeDeleted) {
      const { items } = await api.client
        .getTeamClients(payload.clinicId, String(teamId), {
          // get latest archived clients
          status: 1,
          sorting: 2,
          pageSize: 10,
          pageNumber: 1,
        })
        .then(r => r.data);

      // filter out only clients who archived in all teams
      archived = (items || [])
        .filter(
          client =>
            client.teams && client.teams.length > 0 && client.teams.every(team => team.isArchived),
        )
        .map(client => client.id);
    }

    setClientOptionsByTeam({
      items: data.items,
      total: payload.name.length ? undefined : data.total,
      archived,
      includeDeleted: payload.includeDeleted,
      pageNumber: payload.pageNumber,
    });

    // Only clear the selection once the archived-inclusive fetch confirms nothing exists at all.
    if (!data.items.length && data.total === 0 && payload.includeDeleted) {
      setClient(null);
    }

    return data;
  },
);

export default onGetClientOptions;
